import { Middleware } from '../pipe'
import { CashResponse, CashResponseContext, HttpError } from './types'
export const tryJsonParseError = (str: string) => {
  if (!str.includes('{')) {
    return str
  }
  try {
    return JSON.parse(str)
  } catch (e) {
    // do nothing, if we fail it's because we expected json, but got a message with a curly brace in it.
  }
  return str
}
const parseErrorMessage = (response: Response) => {
  return `${response.status} - ${response.statusText}, endpoint:${response.url}`
}

export const rejectOnErrorResponse: Middleware<CashResponse, CashResponseContext> = async (response, context) => {
  if (!response.ok && context?.options?.rejectOnError) {
    const body = tryJsonParseError(await response.text())
    const errorMessage = parseErrorMessage(response)
    throw new HttpError(errorMessage, response.status, body)
  }
  return response
}
